import React, { useState } from "react";
import {  Starttask } from "../Slices/timerslice";
import { addLatestReports } from "../Slices/employeereportslice";
import { useDispatch, useSelector } from 'react-redux';
import { AntdButton, SelectInput } from '../blueplanitUtils/InputField';
import { getOptionsByPath } from "../utilsdata";

import { updateWorkHistoryThunk } from "../Slices/orderSlice";
import { ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT, HEADER_TIMER, TIMER_TASK } from "../Dropdownmanager";


const TaskComponent = ({ onToggleModal }) => {
  const [department, setDepartment] = useState();
  const [task, setTask] = useState();
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);


  const dispatch = useDispatch();

  const inputFieldStyle = {

    width: "100%",

    height: "39px",
  };

  const userid = loginUser?.id
 
  const specificEmployee =  useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const handleStartButtonClick = async () => {
    const now = Date.now();

 
  if (task === 'Break') {
    localStorage.setItem('breakIn', now.toString());
  }
    const payload = { department, task, time: Date.now(), requestId: "" };
    const Reportpayload = {
      userId:userid,
      employeeName: specificEmployee.firstname + " " + specificEmployee.lastname,
      emailId: specificEmployee.email,
      requestId: "N/A",
      reportingTo: specificEmployee.specificEmployee || "N/A",
      clientName: "Blueplanit",
      requestIds: "N/A",
      processType: "",
      taskType: task,
      billable: "No",
      service: "N/A",
      requestCompleted: "N/A",
      startTime: Date.now().toString(),
      startingTime: Date.now(),
      status: "Pending",
      endTime: "",
      overrideHistory: [],
      department: department
    };
    try {
        const valuesObject = {
          userId: userid,
          emailId: "",
          requestId: "",
          clientName: "Blueplanit",
          processType: "",
          taskType: task,
          email: "",
          subject: "",
          body: "",
          startTime: Date.now().toString(),
          endTime: "",
          department:department
        }
       await dispatch(updateWorkHistoryThunk(valuesObject)).unwrap();
      dispatch(addLatestReports(Reportpayload));
    } catch (err) {
      console.error("Error updating work history:", err);
    }
    localStorage.setItem("task", task);
    localStorage.setItem("department", department);
    localStorage.setItem("time", Date.now());
    dispatch(Starttask(payload));
  };
  const isButtonDisabled = !task || !department;
  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "20px",
      margin: "20px",
    },
    dropdownWrapper: {
      width: "45%",
    },
    buttonContainer: {
      marginTop: "20px",
      display: "flex",
      justifyContent: "center",
    },
  };

  return (
    <>
      <div style={styles.container}>
        <div style={styles.dropdownWrapper}>
          <SelectInput
            label="Department"
            options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}
            value={department}
            onChange={setDepartment}
            style={inputFieldStyle}
            placeholder="Select Department"
            allowClear
          />
        </div>
        <div style={styles.dropdownWrapper}>
          <SelectInput
            label="Task"
            options={getOptionsByPath(NestedDatabucket, [HEADER_TIMER,TIMER_TASK])}
            value={task}
            onChange={setTask}
            style={inputFieldStyle}
            placeholder="Select Task"
            allowClear
          />
        </div>
      </div>

      <div style={styles.buttonContainer}>
        <AntdButton type="primary" onClick={handleStartButtonClick} label="Start" disabled={isButtonDisabled} />
      </div>
    </>
  );
};

export default TaskComponent;
